export const WHATSAPP_NUMBER = "2348069804062";
export const SITE_URL = "https://www.zaviramed.com.ng";

const PACKAGE_IMAGE = "/zavkit-4.png";

export const homeTestCategories = ["All Tests"];

export const homeTests = [
  {
    id: "rain-home-kit",
    name: "Rain",
    type: "package",
    category: "All Tests",
    price: 21999,
    image: "/design/kits-rain.webp?v=hires-20261029",
    description: "A private UTI self-sampling kit with Zaviramed WhatsApp support after purchase.",
    includes: ["UTI self-sampling kit", "Instructions for collecting your sample", "Private WhatsApp guidance"],
  },
  {
    id: "sabi-home-kit",
    name: "Sabi",
    type: "package",
    category: "All Tests",
    price: 21999,
    image: "/design/kits-sabi.webp?v=hires-20261029",
    description: "A private STI self-sampling kit with Zaviramed WhatsApp support after purchase.",
    includes: ["STI self-sampling kit", "Instructions for collecting your sample", "Private WhatsApp guidance"],
  },
  {
    // Retained for customers who saved a Zav-Kit 4 cart before the design update.
    id: "zav-kit-4",
    name: "Zav-Kit 4",
    type: "package",
    category: "Sexual Health",
    available: false,
    price: 21999,
    image: "/zavkit-4.png",
    description: "A private Zaviramed home testing kit for HPV, HIV, HBV and syphilis screening.",
    includes: ["Private WhatsApp guidance"],
  },
];

export function formatNaira(value) {
  return `₦${Number(value || 0).toLocaleString("en-NG")}`;
}

export function homeTestPurchaseUrl(test) {
  const message = `Hello Zaviramed, I want to purchase ${
    test.name
  } (${formatNaira(test.price)}).`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message
  )}`;
}
